import { VoucherCard } from 'components/VoucherCard';
import { voucher as getVoucher } from 'services/api/conversation';
import { useQuery } from '@tanstack/react-query';
import { ApiQueryKey } from 'services/config/queryKey';
import { useMemo } from 'react';
import { Spin } from 'antd';
import { cx } from '@emotion/css';

interface VoucherDisplayProps {
  data: Knowledge.Activity.Voucher;
  border?: boolean;
}

export const VoucherDisplay = (props: VoucherDisplayProps) => {
  const { data, border } = props;

  const params = useMemo(() => {
    return {
      internal_store_id: `${data.storeId}`,
      external_voucher_id: data.externalVoucherId,
    };
  }, [data]);
  const { isLoading, data: voucher } = useQuery({
    queryKey: [ApiQueryKey.VoucherCard, params],
    queryFn: ({ queryKey }) => getVoucher(queryKey[1] as any),
    enabled: !!params,
    staleTime: 10 * 60 * 1000,
  });

  if (isLoading) {
    return <Spin spinning />;
  }

  if (!voucher) return null;

  return (
    <VoucherCard
      className={cx(
        'w-80 pl-3 pr-2 mr-4 mt-2',
        border ? 'border border-solid border-[#F0F2F5]' : undefined,
      )}
      voucher={voucher}
      storeId={`${data.storeId}`}
    />
  );
};
